(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["popup-link"] && !Shopify.designMode) return;
  try {
    function enhanceLurveGuides(root = document) {
  root.querySelectorAll('.popup-link--size-guide .rte').forEach(content => {
    if (content.querySelector('.lurve-guide-units')) return;
    const panels = Array.from(content.children).filter(el => el.matches('details') && el.querySelector('table'));
    if (panels.length !== 2) return;
    if (content.closest('.lurve-guide-layout').querySelector('.lurve-guide-figure')) {
      panels.forEach(panel => panel.querySelectorAll('table').forEach(table => table.querySelectorAll('tbody th').forEach((cell, i) => { cell.textContent = `${i + 1}. ${cell.textContent.trim().replace(/^\d+\.\s*/, '')}`; })));
    }
    const controls = document.createElement('div');
    controls.className = 'lurve-guide-units';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', 'Measurement units');
    panels.forEach((panel, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = index === 0 ? 'CM' : 'IN';
      button.setAttribute('aria-pressed', String(index === 0));
      panel.classList.add('lurve-unit-panel');
      panel.open = true;
      panel.hidden = index !== 0;
      button.addEventListener('click', () => {
        panels.forEach((item, i) => { item.hidden = i !== index; });
        Array.from(controls.children).forEach((item, i) => item.setAttribute('aria-pressed', String(i === index)));
      });
      controls.append(button);
    });
    panels[0].before(controls);
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhanceLurveGuides(), { once: true });
else enhanceLurveGuides();
document.addEventListener('shopify:section:load', event => enhanceLurveGuides(event.target));
  } catch(e) { console.error(e); }
})();

})();
